import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Table } from "antd";
import formatError from "../../../services/FormatError";
import { GlobalFilter } from "../../components/table/FilteringTable/GlobalFilter";
import { loginConfirmedAction } from "../../../store/actions/AuthActions";
import { sortList } from "../Users";
import { dateFormatter } from "../BuyerProfile";
import {
  addSellerProfile,
  deleteSellerProfile,
  fetchAllSellers,
  fetchSellerDetails,
} from "../../../services/SellerService";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";
import { getBase64 } from "../Registration";
import { fetchAllRepresentatives } from "../../../services/RepresentativeService";
import {
  addUserProfile,
  deleteUser,
  fetchUserDetails,
} from "../../../services/UserServices";
import config from "../../../config";
import { useLoadScript, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];

export const validateSeller = (data) => {
  if (
    data?.firstname !== "" &&
    data?.lastname !== "" &&
    data?.username !== "" &&
    data?.email !== "" &&
    data?.phone !== "" &&
    data?.address !== "" &&
    data?.city !== "" &&
    data?.country !== ""
  ) {
    return false;
  } else {
    return true;
  }
};

function RepresentativeProfile() {
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const { t } = useTranslation();
    const { isLoaded } = useLoadScript({googleMapsApiKey: config.googleMapsApiKey,libraries,});
  const role = userDetails?.result;

  const state = useSelector((state) => state.auth.auth.result);

  const navigate = useNavigate();

  const location = useLocation();

  const dispatch = useDispatch();

  const [sellerProfiles, setSellerProfiles] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, setGridFilter] = useState("");

  const [addSeller, setAddSeller] = useState(false);

  const [triggered, setTriggered] = useState(false);

  const [sellerDetails, setSellerDetails] = useState({
    firstname: "",
    lastname: "",
    username: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    country: "",
  });

  const [updateSeller, setUpdateSeller] = useState({
    cond: false,
    id: null,
  });
  console.log("updateSeller", updateSeller);
  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const fileInputRef = useRef(null);

  const [selectedFile, setSelectedFile] = useState(null);

  const [base64, setBase64] = useState("");

  useEffect(() => {
    if (location?.state === true) {
      onCreateSeller();
    }
  }, [location?.state]);

  useEffect(() => {
    fetchAllSellerProfiles();
  }, [state, tableParams.current, tableParams.pageSize]);

  const fetchAllSellerProfiles = async () => {
    if (role?.role?.id !== 3) {
      fetchAllRepresentatives(tableParams.current, tableParams.pageSize)
        .then((res) => {
          const response = res.data?.result;

          const sortedList = sortList(response?.data ?? []);

          setSellerProfiles({
            original: [...sortedList],
            filtered: [...sortedList],
          });

          setTableParams((prevTableParams) => ({
            ...prevTableParams,
            total: response?.count,
          }));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    } else {
      if (role?.user?.sellerprofile?.id === 0) {
        setSellerProfiles({
          original: [],
          filtered: [],
        });
      } else {
        const sellerId = role?.user?.sellerprofile?.id ?? null;
        if (sellerId) {
          fetchSellerDetails(sellerId)
            .then((res) => {
              const data = res.data?.result;

              setSellerProfiles({
                original: [data],
                filtered: [data],
              });
            })
            .catch((error) => {
              formatError(error?.response?.data?.error);
            });
        }
      }

      setTableParams((prevTableParams) => ({
        ...prevTableParams,
        total: 1,
      }));
    }
  };

  const updateGridData = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const filteredData = sellerProfiles.original.filter((item) =>
        (item?.firstname + " " + item?.lastname)
          .toLowerCase()
          .includes(value.toLowerCase())
      );

      setSellerProfiles((prevState) => ({
        ...prevState,
        filtered: filteredData,
      }));
    } else {
      setSellerProfiles((prevState) => ({
        ...prevState,
        filtered: [...prevState.original],
      }));
    }
  };

  const onCreateSeller = () => {
    setAddSeller(true);

    setSellerDetails({
      firstname: role?.user?.firstname || "",
      lastname: role?.user?.lastname || "",
      username: role?.user?.username || "",
      role: role?.role?.id,
      email: role?.user?.email || "",
      phone: role?.user?.phone || "",
      address: role?.user?.address || "",
      city: role?.user?.city || "",
      country: role?.user?.country || "",
    });
  };

  const updateSellerDetails = (key, value) => {
    setSellerDetails((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const addSellerHandler = (id) => {
    if (validateSeller(sellerDetails)) {
      setTriggered(true);
    } else {
      setTriggered(false);

      addUserProfile({ ...sellerDetails, id: updateSeller.id }, false)
        .then((res) => {
          swal(t("hrepresentativeupdate"), "", "success");
          setSellerDetails({
            firstname: "",
            lastname: "",
            username: "",
            email: "",
            phone: "",
            address: "",
            city: "",
            country: "",
          });

          if (updateSeller.cond) {
            setUpdateSeller({
              cond: false,
              id: null,
            });
          }

          setAddSeller(false);

          const newSessionDetails = { ...userDetails };

          newSessionDetails.result.user.sellerprofile = res?.data?.result;

          sessionStorage.setItem(
            "userDetails",
            JSON.stringify(newSessionDetails)
          );

          dispatch(loginConfirmedAction(newSessionDetails));
        })
        .catch((error) => {
          formatError(error.response?.data?.error);
        });
    }
  };

  const onBackCreate = () => {
    setAddSeller(false);

    setSellerDetails({
      firstname: "",
      lastname: "",
      username: "",
      email: "",
      phone: "",
      address: "",
      city: "",
      country: "",
    });
  };

  // address autocomplete 
    const searchBoxRef = useRef(null);
    // const [addressInput, setAddressInput] = useState(buyerDetails?.address || "");
  
      const handlePlacesChanged = () => {
        // console.log(searchBoxRef.current,"adresse")
       if (!searchBoxRef.current) return; // 
  
        updateSellerDetails("address", "");
        updateSellerDetails("city", "");
        updateSellerDetails("region", "");
        updateSellerDetails("postalCode", "");
        updateSellerDetails("country", "");
  
      const places = searchBoxRef.current.getPlaces();
      if (places.length > 0) {
        const place = places[0];
        const addressComponents = place.address_components;
  
        let address  = "";
        let streetNumber="";
        let route ="";
        let city = "";
        let region = "";
        let postalCode = "";
        let country = "";
  
        addressComponents.forEach((component) => {
          const types = component.types;
  
          if (types.includes("street_number")) {
            address = component.long_name ;
          }
          if (types.includes("route")) {
            address = component.long_name;
          }
          if (types.includes("locality")) {
            city = component.long_name;
          }
          if (types.includes("administrative_area_level_1")) {
            region = component.long_name;
          }
          if (types.includes("postal_code")) {
            postalCode = component.long_name;
          }
          if (types.includes("country")) {
            country = component.long_name;
          }
        });
        console.log(address,"adresse")
  
        updateSellerDetails("address", address); 
  
      //  updateBusinessDetails("address", address);
        updateSellerDetails("city", city);
        updateSellerDetails("region", region);
        updateSellerDetails("postalCode", postalCode);
        updateSellerDetails("country", country);
      }
    };
  // End address autocomplete

  const onViewSeller = (id) => {
    navigate(`/representative/${id}`);
  };

  const onUpdateSeller = (id) => {
    fetchUserDetails(id)
      .then((res) => {
        const data = res.data?.result;

        setUpdateSeller({
          cond: true,
          id: data?.id,
        });

        setAddSeller(true);

        setSellerDetails({
          firstname: data?.firstname || "",
          lastname: data?.lastname || "",
          username: data?.username || "",
          email: data?.email || "",
          phone: data?.phone || "",
          address: data?.address || "",
          city: data?.city || "",
          country: data?.country || "",
        });
      })
      .catch((error) => {
        formatError(error?.response?.data?.error);
      });
  };

  const onDeleteSeller = (id) => {
    swal({
      title: t("are_you_sure"),
      text: t("confirmationDelete"),
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteUser(id)
          .then((res) => {
            swal(t("hsuppressionsuccess"), "", "success");
            fetchAllSellerProfiles();
          })
          .catch((error) => {
            formatError(error.response?.data?.error);
          });
      }
    });
  };

  const onChangePhoto = async (e) => {
    const file = e.target.files[0];

    const sizeLimit = 50 * 1024 * 1024; // 50MB

    if (file) {
      const fileType = file.type;

      if (file.size > sizeLimit) {
        swal("Oops", t("hmax50"), "error", {
          button: t("htry"),
        });

        fileInputRef.current.value = "";
        setSelectedFile(null);

        setBase64("");

        return;
      }

      // Check if the selected file is of type jpg or png
      if (fileType === "image/jpeg" || fileType === "image/png") {
        const base64String = await getBase64(file);

        setSelectedFile(file);
        setBase64(base64String);
      } else {
        fileInputRef.current.value = "";

        setSelectedFile(null);
        setBase64("");

        swal("Oops", t("hselectJpg"), "error", {
          button: t("htry"),
        });
      }
    }
  };

  const columns = [
    {
      title: `${t("sellerProfileCulumn1")}`,
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t("sellerProfileCulumn2")}`,
      dataIndex: "name",
      sorter: true,
      render: (text, record) => {
        return (
          <>
            <span>{record?.firstname + " " + record?.lastname}</span>
            <br />
            <span className="text-muted">{record?.email}</span>
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn5")}`,
      dataIndex: "address",
      render: (text, record) => {
        return (
          <>
            {record?.address ? (
              <span>{record?.address}</span>
            ) : (
              <span className="text-muted">-</span>
            )}
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn6")}`,
      dataIndex: "city",
      render: (text, record) => {
        return (
          <>
            {record?.city ? (
              <span>{record?.city}</span>
            ) : (
              <span className="text-muted">-</span>
            )}
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn3")}`,
      dataIndex: "country",
      render: (text, record) => {
        return (
          <>
            {record?.country ? (
              <span>{record?.country}</span>
            ) : (
              <span className="text-muted">-</span>
            )}
          </>
        );
      },
      width: "20%",
    },
    {
      title: `${t("sellerProfileCulumn4")}`,
      dataIndex: "createdat",
      render: (text) => dateFormatter(text),
      width: "20%",
    },

    {
      title: `${t("sellerProfileCulumn7")}`,
      dataIndex: "actions",
      render: (text, record) => {
        return (
          <div class="d-flex action-button">
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              style={{ fontSize: "15px", marginRight: "8px" }}
              onClick={() => onViewSeller(record?.id)}
            >
              <i className="fa fa-eye"></i>
            </a>
            <a
              href="javascript:void(0);"
              class="btn btn-info btn-xs light px-2"
              onClick={() => onUpdateSeller(record?.id)}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17 3C17.2626 2.73735 17.5744 2.52901 17.9176 2.38687C18.2608 2.24473 18.6286 2.17157 19 2.17157C19.3714 2.17157 19.7392 2.24473 20.0824 2.38687C20.4256 2.52901 20.7374 2.73735 21 3C21.2626 3.26264 21.471 3.57444 21.6131 3.9176C21.7553 4.26077 21.8284 4.62856 21.8284 5C21.8284 5.37143 21.7553 5.73923 21.6131 6.08239C21.471 6.42555 21.2626 6.73735 21 7L7.5 20.5L2 22L3.5 16.5L17 3Z"
                  stroke="#fff"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </svg>
            </a>
            {(role?.role?.id === 1 || role?.role?.id === 2) && (
              <a
                href="javascript:void(0);"
                class="ms-2 btn btn-xs px-2 light btn-danger"
                style={{ marginRight: "8px" }}
                onClick={() => onDeleteSeller(record?.id)}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 6H5H21"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                  <path
                    d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </a>
            )}
          </div>
        );
      },
      width: "20%",
    },
  ];

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };
   if (!isLoaded) return <div>Loading...</div>;

  return (
    <>
      <div class="card">
        <div class="card-header d-sm-flex d-block">
          {addSeller ? (
            <div class="d-flex me-auto mb-sm-0">
              <span
                style={{ fontSize: "18px", cursor: "pointer" }}
                className="d-flex justify-content-start align-items-center me-3"
                onClick={onBackCreate}
              >
                <i className="fa fa-arrow-left"></i>
              </span>
              <h4 class="card-title">
                {updateSeller?.cond ? t("update") : t("globalCreateButton")}{" "}
                {t("representativeProfileTitle2")}
              </h4>
            </div>
          ) : (
            <>
              <div class="d-flex me-auto mb-sm-0">
                <h4 class="card-title">
                  {t("representativeProfileTitle2")}
                  {role?.role?.id !== 3 ? "S" : ""}
                </h4>
              </div>
              <GlobalFilter filter={gridFilter} setFilter={updateGridData} />
              {role?.role?.id === 3 && role?.user?.sellerprofile && (
                <div style={{ paddingLeft: "12px" }}>
                  <a
                    href="javascript:void(0);"
                    class="btn btn-info"
                    onClick={onCreateSeller}
                  >
                    + {t("sellerProfileCreateButton")}
                  </a>
                </div>
              )}
            </>
          )}
        </div>

        {!addSeller && (
          <div class="card-body">
            <Table
              columns={columns}
              rowKey={(record) => record.id}
              dataSource={sellerProfiles.filtered}
              pagination={tableParams}
              onChange={handleTableChange}
            />
          </div>
        )}
      </div>

      {addSeller && (
        <div className="row overflow-y-scroll">
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.firstname === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("firstnameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("firstnameInput")}
                className="form-control"
                value={sellerDetails?.firstname}
                onChange={(e) =>
                  updateSellerDetails("firstname", e.target.value)
                }
              />
            </div>
            {triggered && sellerDetails?.firstname === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("firstnameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.lastname === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("lastnameInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("lastnameInput")}
                className="form-control"
                value={sellerDetails?.lastname}
                onChange={(e) =>
                  updateSellerDetails("lastname", e.target.value)
                }
              />
            </div>
            {triggered && sellerDetails?.lastname === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("lastnameInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.username === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("loginUsername")}</strong>
              </label>
              <input
                type="text"
                placeholder="Username"
                className="form-control"
                value={sellerDetails?.username}
                onChange={(e) =>
                  updateSellerDetails("username", e.target.value)
                }
              />
            </div>
            {triggered && sellerDetails?.username === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("loginUsername")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.email === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("emailInput")}</strong>
              </label>
              <input
                type="email"
                placeholder={t("emailInput")}
                className="form-control"
                value={sellerDetails?.email}
                onChange={(e) => updateSellerDetails("email", e.target.value)}
              />
            </div>
            {triggered && sellerDetails?.email === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("emailInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.phone === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("phoneInput")}</strong>
              </label>
              <input
                type="number"
                placeholder={t("phoneInput")}
                className="form-control"
                value={sellerDetails?.phone}
                onChange={(e) => updateSellerDetails("phone", e.target.value)}
              />
            </div>
            {triggered && sellerDetails?.phone === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("phoneInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.address === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("addressInput")}</strong>
              </label>
              <StandaloneSearchBox onLoad={(ref) => (searchBoxRef.current = ref)} onPlacesChanged={handlePlacesChanged}>     
              <input
                type="text"
                placeholder={t("addressInput")}
                className="form-control"
                value={sellerDetails?.address}
                onChange={(e) =>{
                    updateSellerDetails("address", e.target.value)
                    updateSellerDetails("city", "");
                    updateSellerDetails("region", "");
                    updateSellerDetails("postalCode", "");
                    updateSellerDetails("country", "");
                  } }
              />
              </StandaloneSearchBox>
            </div>
            {triggered && sellerDetails?.address === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("addressInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.city === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("cityInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("cityInput")}
                className="form-control"
                value={sellerDetails?.city}
                onChange={(e) => updateSellerDetails("city", e.target.value)}
              />
            </div>
            {triggered && sellerDetails?.city === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("cityInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div
              className={`form-group ${
                triggered && sellerDetails?.country === "" ? "mb-1" : "mb-3"
              }`}
            >
              <label className="mb-1">
                <span className="text-danger">*</span>
                &ensp;
                <strong>{t("countryInput")}</strong>
              </label>
              <input
                type="text"
                placeholder={t("countryInput")}
                className="form-control"
                value={sellerDetails?.country}
                onChange={(e) => updateSellerDetails("country", e.target.value)}
              />
            </div>
            {triggered && sellerDetails?.country === "" && (
              <div className="text-danger fs-12 mb-3">
                {t("countryInput")} {t("globalIsRequired")}
              </div>
            )}
          </div>

          <div className="col-md-12 col-lg-6 col-xl-4">
            <div className="form-group mb-3">
              <label className="mb-1">
                <strong>{t("photoInput")}</strong>
              </label>
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                className="form-control"
                ref={fileInputRef}
                onChange={onChangePhoto}
                // disabled={!isObjectEmpty(sellerDetails)}
              />
            </div>
          </div>

          <div className="col-md-12 mb-5">
            {updateSeller.cond ? (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => addSellerHandler(updateSeller.id)}
                >
                  {t("globalUpdateButton")}
                </button>
              </div>
            ) : (
              <div className="d-flex justify-content-center align-items-center">
                <button
                  type="button"
                  className="btn btn-success"
                  onClick={() => addSellerHandler(null)}
                >
                  {t("globalCreateButton")}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default RepresentativeProfile;
